export const ACTION_RESET = 'FETCH_SHOWCASE_RESET';
export const ACTION_REQUEST = 'FETCH_SHOWCASE_REQUEST';
export const ACTION_SUCCESS = 'FETCH_SHOWCASE_SUCCESS';
export const ACTION_ERROR = 'FETCH_SHOWCASE_ERROR';
